import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import FooterBottom from './FooterBottom';

const FooterSmall = ({
    t, openPage, language, type
}) => (
    <div className={ cx('container-footer-small', type) } id={ cx('container-footer-small', type) }>
        <div className="layout">
            <FooterBottom t={ t } openPage={ openPage } language={ language }/>
        </div>
    </div>
);

FooterSmall.defaultProps = {
    type: 'general'
};

FooterSmall.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    type: PropTypes.string
};

export default FooterSmall;



// WEBPACK FOOTER //
// ./src/components/content/common/FooterSmall.jsx